<div class="col" style="border: 4px solid black;" >
<h2>{{name}}</h2>
<!--<ngx-barcode6 [bc-value]="barcodeValue" [bc-display-value]="true"></ngx-barcode6>-->
</div>

